import { DatePicker } from 'antd';

export default DatePicker;
